import React from 'react'
import Header from './component/Header'
import Content from './component/Content'
import Footer from './component/Footer'

const App = () => (
  <>
    <Header />
    <Content />
    <Footer />
  </>
)

export default App
